import { Link } from '@/types/general';
import qs from 'qs';

/**
 * Returns the uuid of the provided self link
 * @param link
 * @returns
 */
export function getUidFromSelfLink(link: Link): string {
  return getUidsFromUri(link.uri)[0];
}

/**
 * This should only be used for retrieving ids that are not in for uuid format.
 * If possible, it's better to use getUidFromSelfLink or getUidsFromUri.
 * @param uri
 * @returns
 */
export function getIdFromUri(uri: string): string {
  // return value after last forward slash
  const split = uri.split('/');
  return split[split.length - 1];
}

/**
 * Returns an array of uuids found in the provided uri
 * @param uri
 * @returns
 */
export function getUidsFromUri(uri: string) {
  if (!uri) {
    return [];
  }
  return uri.match(/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/g) ?? [];
}

export function createResourceUri(
  baseUrl: string,
  options?: { uid?: string; resource?: string; queryParams?: Record<string, any> }
): string {
  const path = options?.resource ?? '';
  const uri = options?.uid ? `${baseUrl}/${options.uid}${path}` : `${baseUrl}${path}`;

  if (options?.queryParams) {
    const queryString = qs.stringify(options.queryParams, { arrayFormat: 'brackets' });
    return `${uri}?${queryString}`;
  }

  return uri;
}
